import AppLayout from "../../components/Layout";
import React from "react";

export default function Forum() {
  return <div>Forum</div>;
}
